import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    // ซ่อนบนจอเล็กกว่า lg — แถบนี้ค้างอยู่ล่างจอตลอด (main เป็นกล่องเลื่อนเอง) กิน 61px ของมือถือ/iPad แนวตั้งไปเปล่า ๆ (28 ก.ย. 69)
    <footer className="hidden lg:block bg-[#f5f5f7] dark:bg-[#1c1c1e] border-t border-slate-200/50 dark:border-[#38383a]">
      <div className="max-w-7xl mx-auto px-4 py-6 text-center text-sm text-slate-500 dark:text-slate-400">
        {t("footer.copyright", { year: new Date().getFullYear() })}
      </div>
    </footer>
  );
};

export default Footer;
